import { ReportTypeStatus } from '@features/siteStatusV2/constants/report';

const MapWorkOrderStatusToDisplay: Record<ReportTypeStatus, string> = {
  [ReportTypeStatus.SERVICE_INTERRUPTED]: 'report.reportType.serviceInterrupted',
  [ReportTypeStatus.SERVICE_DEGRADED]: 'report.reportType.serviceDegraded',
  [ReportTypeStatus.SAV]: 'report.reportType.sav',
  [ReportTypeStatus.NO_STATUS]: '-'
};

export default MapWorkOrderStatusToDisplay;
